module.exports = __webpack_public_path__ + "img/course97_curriculum.ccdfb454.png";